const rootActionPath = 'core/InstoreManageCardsModal';

export const INSTORE_MANAGE_CARDS_MODAL_TRIGGER = `${rootActionPath}/TRIGGER`;
export const INSTORE_MANAGE_CARDS_MODAL_CLEAR = `${rootActionPath}/CLEAR`;
